import config from 'config';
import { yearMonthToMoment, isoDate } from 'utils/LocalDateTimeHelper';

const LOAD_MATCHES = 'football/competitions/LOAD_MATCHES';
const LOAD_MATCHES_SUCCESS = 'football/competitions/LOAD_MATCHES_SUCCESS';
const LOAD_MATCHES_FAIL = 'football/competitions/LOAD_MATCHES_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_MATCHES:
      return {
        ...state,
        loading: true
      };
    case LOAD_MATCHES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        matches: action.result
      };
    }
    case LOAD_MATCHES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.competitionMatches
      && globalState.football.competitionMatches.loading;
}

export function loadCompetitionMatches(competitionId, month, fixturesResults) {
  let params;

  if (!month) {
    params = {
      default_month: true
    }
  }
  else {
    params = {
      from: isoDate(yearMonthToMoment(month).startOf('month')),
      to: isoDate(yearMonthToMoment(month).add(1, 'month').startOf('month'))
    }
  }

  params = {
    ...params,
    results_only: fixturesResults == "results"
  }

  return {
    types: [LOAD_MATCHES, LOAD_MATCHES_SUCCESS, LOAD_MATCHES_FAIL],
    promise: client => client.get(`${config.api.football.competitions}/${competitionId}/matches`, {params})
  }
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/competitionMatches.js